import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";

export const Tr = styled.form`
  display: table-row;
  height: 1.75rem;

  background-color: ${(props) =>
    props.highlighted ? COLORES.HIGHLIGHTED : COLORES.BACKGROUND};

  :hover {
    background-color: ${COLORES.HIGHLIGHTED};
  }

  color: ${(props) => props.deleted && COLORES.DELETED};
`;

export const Td = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};

  ${(props) =>
    props.type !== "enum" &&
    props.type !== "relate" &&
    css`      
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  button {
    font-weight: bold;
    border: none;
    border-radius: 0.2rem;
    margin-left: 0 0.2rem;
    color: ${COLORES.BUTTON_TEXT_DEFAULT};
    background-color: ${COLORES.BUTTON_BACKGROUND_DEFAULT};
    line-height: 1.35rem;
  }
`;

export const Checkbox = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};
  text-align: center;
`;

export const InputCheckbox = styled.input`
  vertical-align: middle;
`;

export const Buttons = styled.div`
  display: flex;

  button {
    flex-grow: 1;
    margin-left: 0.2rem;

    :disabled {
      cursor: default;
      background-color: ${COLORES.BACKGROUND_DISABLED};
    }
  }
  button:last-of-type {
    margin-right: 0.2rem;
  }

  .action {
    font-weight: bold;
    font-size: 0.75rem;
  }

  .save {
    background-color: ${COLORES.FORWARD};
  }

  .cancel {
    background-color: ${COLORES.BACKWARD};
  }

  .edit {
    font-size: 0.8rem;
  }
`;
